import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'pdhstar-card-manager-admin-layout',
    templateUrl: './admin-layout.component.html',
    styleUrls: ['./admin-layout.component.scss']
})
export class AdminLayoutComponent implements OnInit {
    constructor(public router: Router) {
    }

    public isCollapsed = false;

    public innerWidth: number = -1;
    public defaultSidebar: string = '';
    public showMobileMenu = false;
    public expandLogo = false;

    options = {
        sidebartype: 'full'
    };

    Logo() {
        this.expandLogo = !this.expandLogo;
    }

    ngOnInit() {
        this.defaultSidebar = this.options.sidebartype;
        this.handleSidebar();
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: string) {
        this.handleSidebar();
    }

    handleSidebar() {
        this.innerWidth = window.innerWidth;
        switch (this.defaultSidebar) {
            case 'full':
                if (this.innerWidth < 1170) {
                    this.options.sidebartype = 'mini-sidebar';
                } else {
                    this.options.sidebartype = this.defaultSidebar;
                }
                break;
            default:
        }
    }
}

